/* ui/color-ramp.js — sekventiell 3-stop linjär färgskala.
 *
 * Cream → Orange → Dark Brown. Matchar prod karta.js (samma RGB-stops).
 * Ingen extern dependency (chroma.js, d3-scale etc.) — ~30 rader pure math.
 *
 * Public API:
 *   rampColor(t)     — t ∈ [0,1] → 'rgb(r,g,b)'-sträng
 *   gradientCSS()    — CSS linear-gradient för legend-bar
 */

const STOPS = [
    [0.0, [244, 227, 212]],  // #f4e3d4 cream
    [0.5, [184,  83,  42]],  // #b8532a orange
    [1.0, [ 74,  30,  16]],  // #4a1e10 dark brown
];

export function rampColor(t) {
    t = Math.max(0, Math.min(1, t));
    for (let i = 0; i < STOPS.length - 1; i++) {
        const [t1, c1] = STOPS[i];
        const [t2, c2] = STOPS[i + 1];
        if (t <= t2) {
            const u = (t - t1) / (t2 - t1 || 1);
            const r = Math.round(c1[0] + (c2[0] - c1[0]) * u);
            const g = Math.round(c1[1] + (c2[1] - c1[1]) * u);
            const b = Math.round(c1[2] + (c2[2] - c1[2]) * u);
            return `rgb(${r},${g},${b})`;
        }
    }
    return '#4a1e10';
}

export function gradientCSS() {
    const parts = STOPS.map(([t, c]) => `rgb(${c[0]},${c[1]},${c[2]}) ${(t * 100).toFixed(0)}%`);
    return `linear-gradient(to right, ${parts.join(', ')})`;
}

/* n jämnt fördelade prov ur samma ramp — klassfärgerna för en binnad
 * choropleth (map/choropleth.js) och rutorna i dess legend. Samma funktion
 * på båda ställena med flit: en legend som samplar rampen på sitt eget sätt
 * skulle visa en annan nyans än kartan för samma klass.
 * n === 1 → mitten, annars 0…1 inklusive båda ändarna. */
export function rampColors(n) {
    if (n <= 1) return [rampColor(0.5)];
    const out = [];
    for (let i = 0; i < n; i++) out.push(rampColor(i / (n - 1)));
    return out;
}
